var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',[_vm._v("Registrering bekreftet")]),_c('p',[_vm._v(" Nå kan du logge deg inn ved å klikke "),_c('router-link',{attrs:{"to":{ name: 'login' }}},[_vm._v("her")])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }